import {Pipe,PipeTransform} from '@angular/core';

@Pipe({
    name:'listColumnAccessCheckerPipe',
    pure:true
})

export class ListColumnAccessCheckerPipe implements PipeTransform {
    transform(columnList:[],columnName:string):boolean{
        return !!columnList.find(val => val === columnName);
    }
}